// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__4ORg_","lysTekst":"Footer_lysTekst__2cRjI"};